export const ERROR_01 = "ERR_API_KEY_COURIER_NOT_AVAILABLE"
export const ERROR_02 = "ERR_ORDER_ID_NOT_WAITING_STATUS"
export const ERROR_03 = "ORDER_ID_NOT_FOUND"
export const ERROR_04 = "ERROR_INSUFFICIENT_BALANCE_WITHDRAW"
export const ERROR_05 = "ERROR_CHECK_DUPLICATED_DROPOFF"
export const ERROR_06 = "NOT_SUPPORT_COD"

export const censorCodeDraftOrderAPI = [
    ERROR_01,
    ERROR_02,
    ERROR_03
]
export const censorCodeBuyTotal = [
    ERROR_04,
    ERROR_05,
    ERROR_06
]